import { render } from "./GoodsDetail.vue?vue&type=template&id=e1a493fe&scoped=true"
import script from "./GoodsDetail.vue?vue&type=script&lang=js"
export * from "./GoodsDetail.vue?vue&type=script&lang=js"

import "./GoodsDetail.vue?vue&type=style&index=0&id=e1a493fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1a493fe"]])

export default __exports__